/**
 * Created by zhangxiaoqing on 2017/7/19.
 */
// import Vue from 'vue'
// import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import login from './modules/login'
import webset from './modules/webset'
import getApp from './modules/getApp'
import admin from './modules/adminMan'
// import createLogger from 'vuex/dist/logger'

// Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    login,
    webset,
    getApp,
    admin
  },
  strict: debug,
  plugins: []
})



// WEBPACK FOOTER //
// ./src/store/index.js